import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Type from '@/pages/repair/type/type'
import SubmitTicket from '@/pages/repair/submit-ticket/submit-ticket'
import TicketList from '@/pages/repair/ticket-list/ticket-list'
import TicketDetail from '@/pages/repair/ticket-detail/ticket-detail'
import Evaluation from '@/pages/repair/evaluation/evaluation'

function Repair({ match }: any) {
  return (
    <Switch>
      <Route exact path={`${match.path}/type`} component={Type} />
      <Route exact path={`${match.path}/submit`} component={SubmitTicket} />
      <Route exact path={`${match.path}/list`} component={TicketList} />
      <Route exact path={`${match.path}/detail/:id`} component={TicketDetail} />
      <Route
        exact
        path={`${match.path}/evaluation/:id`}
        component={Evaluation}
      />
    </Switch>
  )
}

export default Repair
